import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { I18nNamespace } from '~/common/types';

interface I18nCellProps<R extends GridValidRowModel = any> {
  ns?: I18nNamespace;
  keyPrefix?: string;
  row: R;
  value: string;
}

export const I18nCell = <R extends GridValidRowModel = any>(props: I18nCellProps<R>) => {
  const { t } = useTranslation(props.ns, { keyPrefix: props.keyPrefix });

  // translate the value
  const value = t(props.value);

  // return simple string value
  return value ? <>{value}</> : <>{NULLISH_CELL_VALUE}</>;
};
